import {Link as Linker, Tab, Tabs} from '@mui/material';
import React, {lazy} from 'react';
import {makeStyles} from '@mui/styles';
import Loadable from '../../../../ui-component/Loadable';

const MenuItem = Loadable(lazy(() => import('./MenuItem')));

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
        '& .MuiTab-root': {
            minWidth: '80px',
            '&.Mui-selected': {
                color: '#4caf50'
            }
        },
        '& .MuiTabs-indicator': {
            backgroundColor: '#4caf50'
        }
    },
    game: {
        display: 'none'
    }
});

export default function Menu({value}) {
    const classes = useStyles();
    return <Tabs scrollButtons='auto' value={value} className={classes.root} centered>
        <MenuItem to={'/'} label='Home'/>
        <Tab component={Linker} href={'https://streamer.soccerstreams-100.tv/'} label='Submit'/>
        <MenuItem to={'/rules'} label='Rules'/>
        <MenuItem to={'/contact'} label='Contact'/>
        <MenuItem to={'/dcma'} label='Dcma'/>
        <MenuItem to={'/privacy'} label='Privacy'/>
        <Tab className={classes.game} value={-1}/>
    </Tabs>;
}